// src/authConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID || 'YOUR_CLIENT_ID',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_TENANT_ID || 'YOUR_TENANT_ID'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    tokenRenewalOffsetSeconds: 86400,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
  // Explicitly exclude offline_access which MSAL v3 adds automatically
  // and which triggers the "maintain access" consent prompt
  extraScopesToConsent: [],
};
